import { useEffect, useState } from "react";

import { Alert } from "@realroof/ui";

import { ACTION_LABEL as LABEL, api, detailText, type AuditItem } from "../api";
import { when } from "../format";
import { Link } from "../router";
import { Table, td, th } from "../table";


/** Who did what, newest first. Nothing here can be edited or deleted. */
export function Audit() {
  const [rows, setRows] = useState<AuditItem[] | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api<AuditItem[]>("/admin/audit?limit=200")
      .then(setRows)
      .catch((err: Error) => setError(err.message));
  }, []);
  return (
    <section className="flex flex-col gap-4">
      <h1 className="text-2xl font-bold">Audit trail</h1>
      {error && <Alert tone="error">{error}</Alert>}
      {rows && (
        <Table>
          <thead>
            <tr>
              <th className={th}>When</th>
              <th className={th}>Who</th>
              <th className={th}>What</th>
              <th className={th}>Details</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className={td + " whitespace-nowrap"}>{when(r.created_at)}</td>
                <td className={td}>{r.staff ?? "system"}</td>
                <td className={td}>
                  {r.target_type === "listing" ? <Link to={`/ads/${r.target_id}`}>{LABEL[r.action] ?? r.action}</Link> : (LABEL[r.action] ?? r.action)}
                </td>
                <td className={td + " text-sm text-muted-foreground"}>
                  {detailText(r.detail)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </section>
  );
}
